import React from "react";
import "./scratch-removal.css";
import { Link } from "react-router-dom";    
import { Helmet } from "react-helmet";
export default function ScratchRemoval() {
  return (
    <>
    <Helmet>
      <title>Car Scratch Removal Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Need car scratch removal in Palwal? AutoCare offers professional scratch repair, paint touch-up, color correction, and protective coating services to restore your car's appearance."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/scratch-removal"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Car Scratch Removal Service in Palwal</h1>

          <p>
            Scratches on your car can spoil its appearance and reduce resale value.
            At <strong>AutoCare</strong>, we provide professional
            <span className="highlight"> car scratch removal services</span>
            using advanced techniques and premium products.
            Trusted <strong>Auto Care in Palwal</strong> for expert
            <span className="highlight"> car repair</span>.
          </p>

          <h2>What is Car Scratch Removal?</h2>
          <p>
            Scratch removal is a specialized <span className="highlight">
            car paint repair</span> process that eliminates surface scratches,
            swirl marks, and minor paint damage without repainting the entire panel.
          </p>

          <h2>Our Scratch Removal Services Include</h2>
          <ul>
            <li>Minor & deep scratch removal</li>
            <li>Clear coat scratch correction</li>
            <li>Paint touch-up & polishing</li>
            <li>Color correction & finishing</li>
            <li>Protective coating after repair</li>
          </ul>

          <h2>Why Choose AutoCare for Scratch Removal?</h2>
          <ul>
            <li>Trained technicians & modern tools</li>
            <li>High-quality products for lasting results</li>
            <li>Affordable pricing & honest advice</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span></li>
            <li>Complete <span className="highlight">car repair</span> services</li>
          </ul>

          <h2>Book Scratch Removal Service with AutoCare</h2>
          <p>
            Looking for <span className="highlight">car scratch removal near me</span>?
            Book your service today with <strong>AutoCare</strong> and restore your
            car’s original shine.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Scratch Removal Service
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/scratchremoval.webp"
            alt="Car Scratch Removal Service in Palwal"
          />
        </div>
      </div>
    </section>
    </>
  );
}
